

exports.__esModule = true;

require('jquery');

require('angularPlaceHolderShim');

require('js/lib/index');

require('xo-tracking/dist/index');

var _squid = require('squid');

var _index = require('squid/index');

var _middleware = require('js/lib/middleware');

require('pages/xo-landing/route');

require('pages/xo-error/route');

require('pages/xo-generic-message/route');

require('pages/xo-openbutton/route');

require('pages/xo-shopping-cart/route');

require('pages/xo-empty-cart/route');

require('pages/xo-inventory-soldout/route');

require('./directive');

var _constants = require('../../js/lib/constants');

var _customUtil = require('../../js/lib/customUtil.js');

var _angular = require('angular');

exports['default'] = _index.$Route.extend('$xoCheckoutRoute', {

    path: 'checkout',
    directive: 'xo-checkout',
    titleContent: 'base.payPal',
    defaultState: 'checkout.landing',
    middleware: _middleware.$Middleware,
    children: [{
        name: '$LandingRoute'
    }, {
        name: '$ErrorRoute'
    }, {
        name: '$GenericMessageRoute'
    }, {
        name: '$xoSoldOutPageRoute'
    }, {
        name: '$ShoppingCartRoute'
    }, {
        name: '$EmptyCartRoute'
    }, {
        name: '$xoOpenButtonRoute'
    }],
    resolve: {
        action: function action() {
            var xClickParams = _customUtil.customUtil.decodeAndParse(_squid.$meta.xclickParams);

            if (xClickParams && xClickParams.wa_type === _constants.BUYNOW_WA_TYPE) {
                _angular.$rootScope.isOpenButton = true;
            } else {
                _angular.$rootScope.isShoppingCart = true;
            }
        }
    }
});


_squid.$meta;

_index.$Route;

_middleware.$Middleware;

_constants.BUYNOW_WA_TYPE;

_customUtil.customUtil;

_angular.$rootScope;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-checkout/route.js
// module id = ./pages/xo-checkout/route.js
// module chunks = 1